import React, { forwardRef, useImperativeHandle } from "react";
import "./index.scss";

const inputType = "outlined";

let EditExchangeForm = ({ data }, ref) => {
  const [exchange_amount, setExchangeAmount] = React.useState("");

  useImperativeHandle(
    ref,
    () => {
      return {
        getValues: () => ({
          exchange_amount,
        }),
        clearVals: () => {
          setExchangeAmount("");
        },
      };
    },
    [exchange_amount]
  );

  React.useEffect(() => {
    if (data) {
      setExchangeAmount(data.exchange_amount ?? "");
    }
  }, [data]);

  return (
    <div>
      <div className="__line __fist">
        <input
          label={"Exchange Amount"}
          value={exchange_amount}
          variant={inputType}
          placeholder="Exchange Amount"
          type="number"
          min={0}
          onChange={(e) => setExchangeAmount(e.target.value)}
          className="__form-input bg-[#f2f8fb]"
        />
      </div>
    </div>
  );
};

export default forwardRef(EditExchangeForm);
